import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "content", "overlay"]

  open() {
    this.dialogTarget.classList.remove("hidden")
    this.overlayTarget.classList.remove("hidden")

    requestAnimationFrame(() => {
      this.contentTarget.classList.remove("hidden", "opacity-0", "scale-95")
      this.contentTarget.classList.add("opacity-100", "scale-100")
    })

    document.body.style.overflow = "hidden"
  }

  close() {
    this.contentTarget.classList.remove("opacity-100", "scale-100")
    this.contentTarget.classList.add("opacity-0", "scale-95")

    setTimeout(() => {
      this.dialogTarget.classList.add("hidden")
      this.overlayTarget.classList.add("hidden")
      this.contentTarget.classList.add("hidden")
      document.body.style.overflow = ""
    }, 200)
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  closeWithEsc(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  submitEnd(event) {
    if (event.detail.success) {
      this.close()
    }
  }
}
